import {
  Box,
  MenuItem,
  Typography,
  Avatar,
  Button,
  Divider,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import PropTypes from "prop-types";
import { routes } from "./../../../routes/routes";
import { useNavigate } from "react-router-dom";
const ProfileDropdown = ({ userDetail }) => {
  let navigate = useNavigate();

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        width: "90px",
        height: "90px",
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  return (
    <Box>
      <Box
        sx={{
          pb: 3,
          mt: 3,
        }}
      >
        <Box display="flex" alignItems="center">
          {userDetail?.isPictureExists ? (
            <>
              {/* <Badge
                color={userDetail?.inOutStatus === "1" ? "success" : "error"}
                variant="dot"
                overlap="circular"
              > */}
              <Avatar
                src={userDetail.picture}
                alt={userDetail.picture}
                sx={{
                  width: "90px",
                  height: "90px",
                }}
              />
              {/* </Badge> */}
            </>
          ) : (
            <>
              {/* <Badge
                color={userDetail?.inOutStatus === "1" ? "success" : "error"}
                variant="dot"
                overlap="circular"
              > */}
              <Avatar
                {...stringAvatar(
                  `${userDetail?.firstName} ${userDetail?.lastName}`
                )}
              />
              {/* </Badge> */}
            </>
          )}
          <Box
            sx={{
              ml: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                lineHeight: "1.235",
              }}
            >
              {userDetail.userName}
            </Typography>
            <Typography color="textSecondary" variant="h6" fontWeight="400">
              {userDetail.department}
            </Typography>
            <Box display="flex" alignItems="center">
              <Typography
                color="textSecondary"
                display="flex"
                alignItems="center"
                sx={{
                  color: (theme) => theme.palette.grey.A200,
                  mr: 1,
                }}
              >
                <FeatherIcon icon="mail" width="18" />
              </Typography>
              <Typography color="textSecondary" variant="h6">
                {userDetail.emailAddress}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: 0,
        }}
      />

      <Box>
        <MenuItem
          sx={{
            pt: 3,
            pb: 3,
          }}
          onClick={() => navigate(routes?.changePassword?.match)}
        >
          <Box display="flex" alignItems="center">
            <Button
              sx={{
                backgroundColor: (theme) => theme.palette.primary.light,
                color: (theme) => theme.palette.primary.main,
                boxShadow: "none",
                minWidth: "50px",
                width: "45px",
                height: "40px",
                borderRadius: "10px",
              }}
            >
              <FeatherIcon icon="lock" width="18" height="18" />
            </Button>
            <Box
              sx={{
                ml: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  lineHeight: "1.235",
                }}
              >
                Change Password
              </Typography>
            </Box>
          </Box>
        </MenuItem>
        <Divider
          style={{
            marginTop: 0,
            marginBottom: 0,
          }}
        />
        {/*  <MenuItem
          sx={{
            pt: 3,
            pb: 3,
          }}
        >
          <Box display="flex" alignItems="center">
            <Button
              sx={{
                backgroundColor: (theme) => theme.palette.success.light,
                color: (theme) => theme.palette.success.main,
                boxShadow: "none",
                minWidth: "50px",
                width: "45px",
                height: "40px",
                borderRadius: "10px",
              }}
            >
              <FeatherIcon icon="shield" width="18" height="18" />
            </Button>
            <Box
              sx={{
                ml: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  lineHeight: "1.235",
                }}
              >
                Active
              </Typography>
              <Typography color="textSecondary" variant="h6" fontWeight="400">
                Active Hours
              </Typography>
            </Box>
          </Box>
        </MenuItem>
        <Divider
          style={{
            marginTop: 0,
            marginBottom: 0,
          }}
        />
        <MenuItem
          sx={{
            pt: 3,
            pb: 3,
          }}
        >
          <Box display="flex" alignItems="center">
            <Button
              sx={{
                backgroundColor: (theme) => theme.palette.error.light,
                color: (theme) => theme.palette.error.main,
                boxShadow: "none",
                minWidth: "50px",
                width: "45px",
                height: "40px",
                borderRadius: "10px",
              }}
            >
              <FeatherIcon icon="credit-card" width="18" height="18" />
            </Button>
            <Box
              sx={{
                ml: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  lineHeight: "1.235",
                }}
              >
                InActive
              </Typography>
              <Typography color="textSecondary" variant="h6" fontWeight="400">
                In-Active Hours
              </Typography>
            </Box>
          </Box>
        </MenuItem>*/}
      </Box>
    </Box>
  );
};

export default ProfileDropdown;
ProfileDropdown.propTypes = {
  userDetail: PropTypes.shape({
    userName: PropTypes.string,
    emailAddress: PropTypes.string,
    department: PropTypes.string,
    inOutStatus: PropTypes.string,
    picture: PropTypes.string,
  }),
};
